import { render, staticRenderFns } from "./OrganizationHeader.vue?vue&type=template&id=a912f58e&scoped=true&"
import script from "./OrganizationHeader.vue?vue&type=script&lang=js&"
export * from "./OrganizationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a912f58e",
  null
  
)

export default component.exports